import loadable from '@wix/yoshi-flow-editor/loadable';

export const Ricos = loadable(() => {
  return import(/* webpackChunkName: "Ricos" */ '../Ricos');
});
